import { Injectable } from "@angular/core"
import { BinanceWebsocketClient } from "../../../market"
import { Observable } from "rxjs"
import { isWsFormattedFuturesUserDataAccountUpdate, WsUserDataEvents } from "libs/binance-api/src"
import { Position, PositionSide } from "../../../model/trade"

@Injectable({
  providedIn: 'root'
})
export class BinancePositionHandler {

  listen(ws: BinanceWebsocketClient) {
    return new Observable<Position>(subscriber => {
      const f = (data: WsUserDataEvents) => {
        if (isWsFormattedFuturesUserDataAccountUpdate(data)) {
          data.updateData.updatedPositions.forEach(row => {
            const position: Position = {
              createdTimestamp: data.transactionTime,
              updateTimestamp: data.transactionTime,
              market: 'binance',
              board: 'usdm',
              symbol: row.symbol,
              entryPrice: row.entryPrice,
              liquidationPrice: undefined,
              size: row.positionAmount,
              positionSide: row.positionSide == 'BOTH' ? PositionSide.both : row.positionSide == 'LONG' ? PositionSide.long : row.positionSide == 'SHORT' ? PositionSide.short : undefined,
              positionVolume: row.entryPrice * row.positionAmount,
              unrealisedPnl: row.unrealisedPnl,
            }
            subscriber.next(position)
          })
        }
      }

      ws.on('formattedUserDataMessage', f)
      return () => ws.off('formattedUserDataMessage', f)
    })
  }

}
